module.exports = __webpack_public_path__ + "static/media/calendar-exclamation.206807c1.svg";